






import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

import {PageContent} from '@app/store/models/PageContent';

import CubPageContent from '@app/common/PageContent.vue';

@Component({
    components: {CubPageContent}
})
export default class Page extends Vue {

    @Prop() public id: string;

    get pageContent(): PageContent | null {
        return  this.id ? this.$store.getters.pageContent(this.id) : null;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/page/Page.vue